module.exports = __webpack_public_path__ + "img/lbma-white.a60694b9.svg";